import { RouteType } from 'app/constants/GlobalTypes'
import { Routes } from 'app/routes/Routes'

export const routes: RouteType[] = [
  {
    key: `${Routes.Checkout.Key}.address`,
    path: Routes.Checkout.member(undefined, false).address,
    component: import('app/pages/Checkout/Views/address'),
    routes: []
  },
  {
    key: `${Routes.Checkout.Key}.machines`,
    path: Routes.Checkout.member(undefined, false).machines,
    component: import('app/pages/Checkout/Views/machines'),
    routes: []
  },
  {
    key: `${Routes.Checkout.Key}.delivery`,
    path: Routes.Checkout.member(undefined, false).delivery,
    component: import('app/pages/Checkout/Views/delivery'),
    routes: []
  },
  {
    key: `${Routes.Checkout.Key}.confirmation`,
    path: Routes.Checkout.member(undefined, false).confirmation,
    component: import('app/pages/Checkout/Views/confirmation'),
    routes: []
  }
]
